import axios from "axios";
import {assertSourceType} from "@babel/core/lib/config/validation/option-assertions";

export default {
    state: () => ({
        priceList : null,
        price : null,

        roomPriceList : null,
        roomPrice : null,

        priceDetailRoomPrice : null,

        pricingPeriodList : null,
        selectedPricingPeriodId : null,
        editPricingPeriod : null
    }),
    mutations: {
        setPriceList:function (state,priceList){
            state.priceList = priceList;
        },
        setPrice:function (state,price){
            state.price = price
        },
        setRoomPriceList:function (state,roomPriceList){
            state.roomPriceList = roomPriceList
        },
        setRoomPrice:function (state,roomPrice){
            state.roomPrice = roomPrice
        },
        setPriceDetailRoomPrice:function (state,priceDetailRoomPrice){
            state.priceDetailRoomPrice = priceDetailRoomPrice
        },
        setPricingPeriodList:function (state, pricingPeriodList){
            state.pricingPeriodList = pricingPeriodList;
        },
        setSelectedPricingPeriodId: function (state, selectedPricingPeriodId){
            state.selectedPricingPeriodId = selectedPricingPeriodId;
        },
        setEditPricingPeriod: function (state, editPricingPeriod){
            state.editPricingPeriod = editPricingPeriod;
        }
    },
    getters: {
        getPriceList : state => {
            return state.priceList
        },
        getPrice : state => {
            return state.price
        },
        getRoomPriceList : state => {
            return state.roomPriceList
        },
        getRoomPrice : state => {
            return state.roomPrice
        },
        getPriceDetailRoomPrice :  state => {
            return state.priceDetailRoomPrice;
        },
        getPricingPeriodList : state => {
            return state.pricingPeriodList;
        },
        getSelectedPricingPeriodId : state => {
            return state.selectedPricingPeriodId;
        },
        getEditPricingPeriod : state => {
            return state.editPricingPeriod;
        }
    },
    actions:{
        loadPricingTemplateList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/pricing/template",{headers})
                .then((response) => {
                    context.commit("setPriceList", response.data)
                    return response.data;
                })
        },
        loadPrice(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/pricing/template/"+id,{headers})
                .then((response) => {
                    context.commit("setPrice", response.data)
                    // TODO: Investigate suspicious code below
                    context.commit("setCruise", {id:response.data.cruiseId})
                    return context.dispatch("loadRoomList")
                })
                .then(response => {
                    return axios.get(context.getters.getServiceUrl + "/admin-api/pricing/template/"+id+"/roomPrice",{headers})
                })
                .then(response => {
                    context.commit("setRoomPriceList", response.data)
                    return context.dispatch("initPriceDetailRoomPrice")
                })
                .then(response => {
                    return context.dispatch("loadPricingPeriodList", id);
                });
        },
        deletePrice(context, price){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/pricing/template/"+price.id,{headers})
                .then((response) => {
                    let priceList = context.getters.getPriceList
                    priceList.splice(priceList.indexOf(price), 1)
                    this.commit("setPriceList",priceList);
                    return response.data;
                })
        },
        createPrice(context, price){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/pricing/template", price,{headers})
                .then((response) => {
                    return this.dispatch("loadPrice",response.data.id);
                })
        },
        updatePrice(context, price){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/pricing/template", price,{headers})
                .then((response) => {
                    return this.dispatch("loadPrice",price.id);
                })
        },
        createRoomPrice(context, roomPrice){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/pricing/template/roomPrice", roomPrice,{headers})
                .then((response) => {
                    context.commit("setRoomPrice", null)
                    //TODO:Temporary callback,this.dispatch("loadCruise", this.getters.getCruise.id)
                    return this.dispatch("loadCruise").then(() => {
                        return this.dispatch("loadPrice", response.data.templateId);
                    });
                })
        },
        updateRoomPrice(context, roomPrice){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/pricing/template/roomPrice", roomPrice,{headers})
                .then((response) => {
                    context.commit("setRoomPrice", null)
                    return this.dispatch("loadCruise");
                })
        },
        createOrUpdateRoomPrice(context, roomPrice){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/pricing/template/roomPrice/createOrUpdate", roomPrice,{headers})
                .then((response) => {
                    context.commit("setRoomPrice", null)
                    return response.data;
                })
        },
        loadPricingPeriodList(context, pricingTemplateId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/pricing/template/"+pricingTemplateId+"/pricing-periods",{headers})
                .then((response) => {
                    context.commit("setPricingPeriodList", response.data)

                    return response.data;
                });
        },
        createPricingPeriod(context, pricingPeriod){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/pricing/template/pricing-periods", pricingPeriod,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        updatePricingPeriod(context, pricingPeriod){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/pricing/template/pricing-periods", pricingPeriod,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deletePricingPeriod(context, pricingPeriodId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/pricing/template/pricing-periods/"+pricingPeriodId,{headers});
        },
        loadExchangeRateHistoryList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/exchange-rate-history",{headers})
                .then((response) => {
                    return response.data;
                });
        },
        initPriceDetailRoomPrice ({state, getters}){
            let roomPriceList = getters.getRoomPriceList;
            let roomList = getters.getRoomList;
            let marketId = getters.getPricingMarketId;
            let pricingPeriod = getters.getSelectedPricingPeriodId;
            let myRoomPrice = {};
            if(roomList == null){
                return null;
            }

            console.log(pricingPeriod);

            for(let i=0;i<roomList.length;i++){
                for(let j=0;j<roomPriceList.length;j++){
                    if(roomList[i].id == roomPriceList[j].roomId
                    && roomPriceList[j].marketId == marketId
                    && roomPriceList[j].pricingPeriodId == pricingPeriod
                    ){
                        myRoomPrice[roomList[i].id] = roomPriceList[j]
                    }
                }
                if(myRoomPrice[roomList[i].id] == null){
                    myRoomPrice[roomList[i].id] = {
                        adultPrice:0,
                        rosDiscount:0,
                        standardDiscount:0,
                        extraGuestMultiplier:0,
                        soloGuestMultiplier:0,
                        taxPrice:0,
                        marketId:getters.getPricingMarketId
                    }
                }
                myRoomPrice[roomList[i].id].roomName = roomList[i].name
                myRoomPrice[roomList[i].id].roomId = roomList[i].id
                myRoomPrice[roomList[i].id].templateId = getters.getPrice.id
                myRoomPrice[roomList[i].id].calculatedAdultPrice =  ((myRoomPrice[roomList[i].id].adultPrice*1 * myRoomPrice[roomList[i].id].soloGuestMultiplier*1) + myRoomPrice[roomList[i].id].taxPrice*1).toFixed(2)
                myRoomPrice[roomList[i].id].calculatedSoloGuestPrice =  ((myRoomPrice[roomList[i].id].adultPrice*1 * myRoomPrice[roomList[i].id].soloGuestMultiplier*1) + myRoomPrice[roomList[i].id].taxPrice*1).toFixed(2)
            }
            state.priceDetailRoomPrice = myRoomPrice;
        }
    }
}

